import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({});

const workDetailsReducer = createReducer(getDefaultState(), {
  [Constants.work.load]: (state, { id }) => ({
    ...state,
    [id]: {
      loading: true
    }
  }),
  [Constants.work.success]: (state, { work }) => ({
    ...state,
    [work.id]: {
      ...work,
      loading: false
    }
  })
});

export default workDetailsReducer;
